import { Button, Popup } from "devextreme-react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import SettingsContent from "./SettingsContent"
import { Component } from "devextreme-react/core/component";
import { PropTypes } from "prop-types";

export const SettingsModal = (props) => {
  const { programId, categoryId, onClose, onSavedData } = props;
  const programList = useSelector((state) => state.userInfo.programs);
  const category = useSelector((state) => state.userInfo.categories);

  Component.propTypes = {
  category: PropTypes.object,
  onClose: PropTypes.func,
  onSavedData: PropTypes.func,
  program: PropTypes.object,
  programId: PropTypes.string
  }
  const showProgramCategoryName = (programId, categoryId) => {
    const categoryList = category[programId];
    let categoryName = "";
    let programName = "";
    programList.forEach((element) => {
      if (element.programId === +programId) {
        programName = element.name;
      }
    });
    categoryList.forEach((element) => {
      if (element.categoryId === +categoryId) {
        categoryName = element.categoryName;
      }
    });
    return programName + " | " + categoryName;
  };


  const { handleSubmit } = useForm();

  const renderTitle = () => {
    return (
      <>
        <span className="note">
          <h3>Settings</h3>
        </span>
        <div className="title" style={{ marginTop: "10px" }}>
          <span
            className="subtitle"
            style={{ fontSize: "medium", fontWeight: "bold" }}
          >
            {showProgramCategoryName(programId, categoryId)}
          </span>
        </div>
      </>
    );
  };
  const renderCloseButton = () => {
    return (
      <div style={{ paddingTop: "10px", right: "1vw", top: "4vh" }}>
        <Button onClick={() => onClose("settings", false)}>X</Button>
      </div>
    );
  };
  const displayTitle = () => {
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {renderTitle()}
          {renderCloseButton()}
        </div>
      </>
    );
  };

  const onSubmit = () => {
    onSavedData();
  };

  return (
    <>
      <Popup
        id="popup"
        visible={true}
        onHiding={onClose}
        showTitle={true}
        titleRender={displayTitle}
        width="40vw"
        resizeEnabled={true}
      >
        <div>
          <div className="dx-fieldset">
            <form onSubmit={handleSubmit(onSubmit)}>

              {<SettingsContent  programId={programId} categoryId={categoryId} onSubmit={onSubmit} />}
            </form>
          </div>
        </div>
      </Popup>

    </>
  );
};
